/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Match_Col_ActionInputs */

const cs_import_match_col_action = /** @type {(inputs: Import_Match_Col_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akce`)
};

const en_import_match_col_action = /** @type {(inputs: Import_Match_Col_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action`)
};

/**
* | output |
* | --- |
* | "Action" |
*
* @param {Import_Match_Col_ActionInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_match_col_action = /** @type {((inputs?: Import_Match_Col_ActionInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Match_Col_ActionInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_match_col_action(inputs)
	return cs_import_match_col_action(inputs)
});